import React from 'react';
import { DataInput } from '../../screens/Profile/data-input/DataInput';
import { ValidatedDataInputProps } from './ValidatedDataInput';
import { FacultyDataKeys } from '../../screens/Profile/FacultyDataKeys';
import { ValidatorResponse, isSupervisorNameValid } from './Validator';

export const TEST_ID = { MAIN: 'input-supervisor-name' };
export const minLength = 2;
export const maxLength = 50;

export interface SupervisorNameInputProps extends ValidatedDataInputProps {}

export const SupervisorNameInput: React.FC<SupervisorNameInputProps> = props => {
  const { whenValidated } = props;
  return (
    <DataInput
      validator={async (value: string) => {
        const isValid: ValidatorResponse = isSupervisorNameValid(value);
        if (!isValid.response) {
          whenValidated?.(false);
          throw new Error(isValid.reason);
        }
        whenValidated?.(true);
      }}
      // Mark this as a guaranteed value (defaultProp) so that TS is happy
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      dataLabel={props.dataLabel!}
      {...props}
    />
  );
};

SupervisorNameInput.defaultProps = {
  dataLabel: 'Supervisor Name',
  name: FacultyDataKeys.supervisorName,
  testId: TEST_ID.MAIN,
  id: 'supervisor-name-input',
  required: true,
  helperMessage: `${maxLength} characters allowed`,
  whenValidated: () => { return; }
};
